import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { byPrefixAndName } from "@awesome.me/kit-1b5e9f4f9d/icons";

const ShareTab = ({ selectedTab, project, netlifyIdentity }) => {
  return (
    <div
      id="share-tab-content"
      className={`box handwriting pb-6 ${selectedTab == "share-tab" ? "" : "is-hidden"
        }`}
      data-content="4"
      style={{ borderRadius: "0px 10px 10px 10px" }}
    >
      <section className="content section">
        <div className="pt-4"></div>
        <h2 className="subtitle is-size-5 mb-0 has-text-dark has-text-weight-normal pb-0">
          Share
        </h2>
        <h1 className="title is-1 mt-2 mb-3">{project.name}</h1>
        <p className="is-size-4">
          Now that you've progressed your idea, it's a good time to invite feedback.
          To share your idea, use the{" "}
          <FontAwesomeIcon
            className="has-text-info"
            icon={byPrefixAndName.fas["arrow-up-from-bracket"]}
          />{" "}
          button in the navbar.
        </p>
        <blockquote>
          "No matter how brilliant your mind or strategy, if you're playing a
          solo game, you'll always lose out to a team."
          <br />
          <i>-- Reid Hoffman</i>
        </blockquote>
        <p>
          Consider these <b>four next steps</b>:
        </p>
        <h3>
          <FontAwesomeIcon
            className="has-text-info"
            icon={byPrefixAndName.fas["circle-1"]}
          />{" "}
          Get an expert opinion
        </h3>
        <p>
          Your Big Picture decisions are where most apps go wrong. It's easy
          to try and appeal to too many people or make too many assumptions
          about what customers need. So, it's a good idea to get others
          involved to scrutinise your strategy and challenge you. If you your colleagues are too close to the business, consider hiring an external consultant.
        </p>

        <h3>
          <FontAwesomeIcon
            className="has-text-info"
            icon={byPrefixAndName.fas["circle-2"]}
          />{" "}
          Validate your strategy
        </h3>
        <p>
          There's nothing worse than building an app that nobody uses (believe me, I've done it). A low-cost way to see if your strategy has legs is to validate it.
          It involves running user research to understand competitors, customer
          pain points and market trends. You'll need to share your strategy with a market research or customer research team.
        </p>

        <h3>
          <FontAwesomeIcon
            className="has-text-info"
            icon={byPrefixAndName.fas["circle-3"]}
          />{" "}
          Test a prototype
        </h3>
        <p>
          If you're confident in your strategy, consider developing a
          prototype and testing it on real people. This will give you a gold
          mine of information about how appropriate your features are for their needs.
        </p>

        <h3>
          <FontAwesomeIcon
            className="has-text-info"
            icon={byPrefixAndName.fas["circle-4"]}
          />{" "}
          Understand development costs
        </h3>
        <p>
          Once you have clarified your strategy and user stories, you can
          invite your internal product team or development partner to estimate
          your project. Use the Estimation tab to quickly learn where the costs are, and then figure out if there is ROI on each feature.
        </p>

        <h3>
          <FontAwesomeIcon
            className="has-text-info"
            icon={byPrefixAndName.fas["circle-5"]}
          />{" "}
          Export to Jira or other tools
        </h3>
        <p>
          Using the estimate tab, you can also pass your stories to your dev team to load into Jira, Linear, Github or Asana.
        </p>

        <div className="box is-shadowless has-background-white-ter mt-6">
          <div className="columns">
            <div className="column is-narrow">
              <figure className="image is-128x128">
                <img className="is-rounded" src="https://www.datocms-assets.com/20955/1579120403-tobin.jpg?auto=compress&fit=contain&fm=jpg&invert=false&sat=-5&w=1080" />
              </figure>
            </div>
            <div className="column">
              Hey {netlifyIdentity?.currentUser()?.name || ''}👋🏼 <br /><br />
              If you need help with your app, share your project link with me via email and let me know which of the above I can help you with. Feel free to email me a message if you'd like to chat first."
              <br /><br />Tobin<br /> Managing Director, Pocketworks<br />Creator of AppFlows
              <br /><a href="mailto:tobin@pocketworks.co.uk">tobin@pocketworks.co.uk</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ShareTab;
